import { Currency } from "@redotech/money/currencies";
import {
  accountIdFormat,
  freightBookingIdFormat,
} from "@redotech/redo-ids/ids";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { FulfillmentOrderAddressSchema } from "../fulfillments/fulfillment-order-address";
import { FreightLocationType, FreightServiceLevel, KnownSCAC } from "./freight";
import {
  DeliveryAccessorialsSchema,
  FreightHandlingUnitSchema,
  FreightQuoteSchema,
  PickupAccessorialsSchema,
} from "./freight-quote-request";

const PurchaseFreightBookingRequestSchema_ = z.object({
  quote: FreightQuoteSchema,
  originAddress: FulfillmentOrderAddressSchema,
  destinationAddress: FulfillmentOrderAddressSchema,
  pickupDateTime: z.string(),
  closeTime: z.string(),
  pickupLocationType: createEnum(FreightLocationType, {
    enumName: "FreightLocationType",
  }).nullish(),
  deliveryLocationType: createEnum(FreightLocationType, {
    enumName: "FreightLocationType",
  }).nullish(),
  pickupAccessorials: PickupAccessorialsSchema,
  deliveryAccessorials: DeliveryAccessorialsSchema,
  handlingUnitList: z.array(FreightHandlingUnitSchema),
  customerReference1: z.string().nullish(),
  customerReference2: z.string().nullish(),
  specialInstructions: z.string().nullish(),
});
export const PurchaseFreightBookingRequestSchema: z.ZodType<PurchaseFreightBookingRequest> =
  PurchaseFreightBookingRequestSchema_;
export interface PurchaseFreightBookingRequest
  extends z.infer<typeof PurchaseFreightBookingRequestSchema_> {}

const PurchaseFreightBookingResponseSchema_ = z.object({
  freightBookingId: freightBookingIdFormat.schema,
});
export const PurchaseFreightBookingResponseSchema: z.ZodType<PurchaseFreightBookingResponse> =
  PurchaseFreightBookingResponseSchema_;
export interface PurchaseFreightBookingResponse
  extends z.infer<typeof PurchaseFreightBookingResponseSchema_> {}

const FreightBookingRowSchema_ = z.object({
  id: freightBookingIdFormat.schema,
  accountId: accountIdFormat.schema,
  bolNumber: z.string(),
  bolUrl: z.string(),
  scac: createEnum(KnownSCAC, { enumName: "KnownSCAC" }),
  serviceLevel: createEnum(FreightServiceLevel, {
    enumName: "FreightServiceLevel",
  }),
  quoteId: z.string(),
  shipmentTransactionId: z.string(),
  pickupTransactionId: z.string(),
  providerCost: z.string(),
  cost: z.string(),
  currency: createEnum(Currency, { enumName: "Currency" }),
  pickupDate: z.date(),
  estDeliveryDays: z.number().nullish(),
  estDeliveryDate: z.date().nullish(),
  trackingLink: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const FreightBookingRowSchema: z.ZodType<FreightBookingRow> =
  FreightBookingRowSchema_;
export interface FreightBookingRow
  extends z.infer<typeof FreightBookingRowSchema_> {}
